export const formInput =
  "px-4 py-3 min-h-[44px] text-base sm:text-sm bg-brand-50 border border-brand-200 rounded-2xl focus:outline-none focus:border-brand-500 w-full text-ink placeholder:text-ink/60 transition-colors";

export const formSelect = `${formInput} cursor-pointer`;

export const formTextarea = `${formInput} resize-none`;

export const formLabel = "block text-xs font-semibold text-ink mb-1.5";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-brand-500 hover:bg-brand-600 text-white text-sm font-semibold px-6 py-3 min-h-[44px] rounded-lg transition-colors disabled:opacity-60";

/** Main (orange) call to action, e.g. form submit. Kept under its old name for existing imports. */
export const btnNavy =
  "inline-flex items-center justify-center gap-2 bg-sun-500 hover:bg-sun-400 text-ink text-sm font-bold px-6 py-3 min-h-[44px] rounded-lg transition-colors disabled:opacity-60";
